<template>
  <header>
    <nav>
      <ul class="left-nav">
        <li><router-link to="/">Home</router-link></li>
        <li v-if="isAuthenticated"><router-link to="/search">Search</router-link></li>
      </ul>
      <ul class="right-nav">
        <li class="logout-button" v-if="isAuthenticated"><button @click="logout">Logout</button></li>
        <li class="session-icon">
          <router-link to="/session">
            <img src="/assets/session-icon.svg" alt="Session" />
          </router-link>
        </li>
        <li class="gear-icon">
          <router-link to="/test">
            <img src="/assets/gear-icon.svg" alt="Settings" />
          </router-link>
        </li>
        <li class="theme-toggle-icon">
          <button @click="toggleTheme">
            <img :src="themeIcon" :alt="themeAltText" />
          </button>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import isAuthenticatedMixin from '../mixins/isAuthenticatedMixin';

export default {
  name: 'Header',
  mixins: [isAuthenticatedMixin],
  computed: {
    ...mapState(['theme']),
    themeIcon() {
      return this.theme === 'light' ? '/assets/moon-icon.svg' : '/assets/sun-icon.svg';
    },
    themeAltText() {
      return this.theme === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode';
    },
  },
  methods: {
    ...mapActions(['logout']),
    ...mapMutations(['toggleTheme']),
  },
};
</script>

<style scoped>
header {
  background: linear-gradient(90deg, #4b79a1, #283e51);
  padding: 15px 30px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
nav {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
nav ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
}
nav ul.left-nav {
  flex: 1;
}
nav ul.right-nav {
  justify-content: flex-end;
}
nav ul li {
  margin-right: 15px;
}
nav ul li a {
  text-decoration: none;
  color: #ecf0f1;
  transition: color 0.3s ease;
}
nav ul li a:hover, nav ul li button:hover {
  color: #f39c12;
}
nav ul li button {
  background: none;
  border: none;
  color: #ecf0f1;
  cursor: pointer;
}
.gear-icon img, .session-icon img, .theme-toggle-icon img {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
</style>